import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Col, Row, Table, Modal, Button, Badge, Card } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import useToken from '../../hooks/useToken';
import ModalModulosPro from './ModalModulosPro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faCheck, faTimes, faCopy } from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ModalSeleccionarOpcionModulos from './Modales/ModalSeleccionarOpcionModulos';
import ModalModulosPRONuevaOrden from './Modales/ModalModulosPRONuevaOrden';
import { useToast } from 'context/providers/ToastProvider';


const SeccionModulosPro = (
    {
        idLicencia,
        idCatTipoLicencia,
        setModulosExtraVinculados,
        modulosExtraVinculados
    }
) => {

    /**
      * AUTENTICACION
      */
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const [cargando, setCargando] = useState(true);
    const [showModalModuloPRO, setShowModalModuloPRO] = useState(false);

    const [modulosProVinculados, setModulosProVinculados] = useState([]);

    const [showModalOpcionModulos, setShowModalOpcionModulos] = useState(false);
    const [showModalModulosPRONuevaOrden, setShowModalModulosPRONuevaOrden] = useState(false);

    // Estados para el manejo de copia de links
    const [copiandoLink, setCopiandoLink] = useState({});
    const [linkCopiado, setLinkCopiado] = useState({});

    useEffect(() => {
        ObtenerListaModulosPRO()
    }, [idLicencia]);

    /***
    /***
    * 
    * DESACTIVAR O ELIMINAR UN MODULO PRO DE UNA LICENCIA
    * 
    */
    const desvincularModuloPro = async (idOrdenDetalle) => {

        const response = await fetch("/api/licencia/DesvincularModulo/?id=" + idLicencia + "&od=" + idOrdenDetalle, {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data["table1"][0].iResponseType == 1) {
                setModulosProVinculados(data["table2"]);
                showSuccessToast(data["table1"][0].vMessage);
            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
    * Aplica Modulo Seleccionado
    */
    const aplicarModuloPro = async (idOrdenDetalle) => {
        const response = await fetch("/api/licencia/AplicarModulo/?id=" + idLicencia + "&od=" + idOrdenDetalle, {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });
        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data["table1"][0].iResponseType == 1) {
                setModulosProVinculados(data["table2"]);
                showSuccessToast(data["table1"][0].vMessage);
            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
    * Aplica Modulo Seleccionado
    */
    const quitarAplicacionModuloPro = async (idOrdenDetalle) => {
        const response = await fetch("/api/licencia/QuitarAplicacionModulo/?id=" + idLicencia + "&od=" + idOrdenDetalle, {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });
        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data["table1"][0].iResponseType == 1) {
                setModulosProVinculados(data["table2"]);
                showSuccessToast(data["table1"][0].vMessage);
            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
    * Obtiene detalles
    */
    const ObtenerListaModulosPRO = async () => {

        setCargando(true);
        const response = await fetch("/api/licencia/ObtenerListaModulosPRO/?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {

            console.log(response);
            const data = await response.json();

            //Módulos PRO vinculados
            console.log("ModulosPRO: ", data);
            setModulosProVinculados(data);
            setCargando(false);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            setCargando(false);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    // Para renovar un módulo vencido
    const [moduloARenovar, setModuloARenovar] = useState(null);
    const [showConfirmModalRenovar, setShowConfirmModalRenovar] = useState(false);
    const RenovarModuloExtra = async (modulo) => {
        const response = await fetch("/api/licencia/RenovarModuloExtra/?idCatModuloLicPOSWeb=" + modulo.idCatModuloLicPOSWeb + "&vCodigoModulo=" + modulo.vCodigoModulo + "&idLicencia=" + idLicencia, {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {

            const data = await response.json();

            if (data["table1"][0].iResponseType == 1) {

                setModulosExtraVinculados(data["table2"]);
                console.log(data["table2"], "ERROR")
                showSuccessToast(data["table1"][0].vMessage);
            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    // Para desvincular un módulo vigente
    const [moduloADesvincular, setModuloADesvincular] = useState(null);
    const [showConfirmModalDesvincular, setShowConfirmModalDesvincular] = useState(false);

    const DesvincularModuloExtra = async () => {

        const response = await fetch("/api/licencia/DesvincularModuloExtra/?idCatModuloLicPOSWeb=" + moduloADesvincular.idCatModuloLicPOSWeb + "&vCodigoModulo=" + moduloADesvincular.vCodigoModulo + "&idLicencia=" + idLicencia, {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {

            const data = await response.json();

            if (data["table1"][0].iResponseType == 1) {

                setModulosExtraVinculados(data["table2"]);
                showSuccessToast(data["table1"][0].vMessage);
            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
    * Obtiene las ordenes para validar que modal abrir
    */
    const ObtenerOrdenesDeModulos = async () => {
        setCargando(true);
        const response = await fetch("/api/licencia/ObtenerOrdenesDeModulos/?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {

            const data = await response.json();

            // Validar iCantidadOrdenes
            const cantidad = Array.isArray(data) && data.length > 0 ? data[0].iCantidadOrdenes : 0;
            if (cantidad > 0) {

                setShowModalOpcionModulos(true);

            } else {

                setShowModalModulosPRONuevaOrden(true);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
        }
    };

    const handleAbrirModalNuevaOrden = () => {
        setShowModalOpcionModulos(false);
        setShowModalModulosPRONuevaOrden(true);
        if (setCargando) setCargando(false);
    };

    /**
     * Copia el enlace de pago al portapapeles
     */
    const copiarLinkPago = async (vUUIDLinkPago, idOrdenDetalle) => {
        if (!vUUIDLinkPago) return;

        setCopiandoLink(prev => ({ ...prev, [idOrdenDetalle]: true }));

        try {
            const response = await fetch(`/api/orden/GetPaymentLink?vUUIDLinkPago=${vUUIDLinkPago}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error);
                return null;
            });

            if (response && response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    // Método alternativo para iOS
                    try {
                        await navigator.clipboard.writeText(data.vMessage);
                        setLinkCopiado(prev => ({ ...prev, [idOrdenDetalle]: true }));
                    } catch (clipboardError) {
                        // Fallback para iOS usando un elemento temporal
                        const textArea = document.createElement('textarea');
                        textArea.value = data.vMessage;
                        textArea.style.position = 'fixed';
                        textArea.style.left = '-999999px';
                        textArea.style.top = '-999999px';
                        document.body.appendChild(textArea);
                        textArea.focus();
                        textArea.select();
                        
                        try {
                            document.execCommand('copy');
                            setLinkCopiado(prev => ({ ...prev, [idOrdenDetalle]: true }));
                        } catch (execError) {
                            console.error('Error al copiar con execCommand:', execError);
                            showErrorToast('No se pudo copiar el enlace. Por favor, cópialo manualmente.');
                        }
                        
                        document.body.removeChild(textArea);
                    }

                    setTimeout(() => {
                        setLinkCopiado(prev => ({ ...prev, [idOrdenDetalle]: false }));
                    }, 2000);
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast(response?.status + ' ' + response?.statusText);
                console.log(response);

                if (response?.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            console.error('Error al copiar al portapapeles:', error);
            showErrorToast('Error al obtener el enlace de pago');
        } finally {
            setCopiandoLink(prev => ({ ...prev, [idOrdenDetalle]: false }));
        }
    };

    return (
        <>
            <Row>
                <Col>
                    <Col>
                        <h5 className="mb-0">
                            {idCatTipoLicencia === 7 ? 'MÓDULOS EXTRA' : 'Módulos PRO'}
                        </h5>
                    </Col>
                </Col>
                <Col className="mx-auto">
                    <div className="d-flex gap-2">
                        <IconButton
                            variant="primary"
                            size="sm"
                            icon="plus"
                            iconAlign="left"
                            onClick={() => { /*setShowModalModuloPRO(true);*/ObtenerOrdenesDeModulos() }}
                            className="d-none d-sm-block"
                        >
                            {idCatTipoLicencia === 7 ? <span>Agregar Módulo Extra</span> : <span>Agregar</span>}
                        </IconButton>

                        {/*<IconButton*/}
                        {/*    variant="primary"*/}
                        {/*    size="sm"*/}
                        {/*    icon="plus"*/}
                        {/*    iconAlign="left"*/}
                        {/*    onClick={() => { setShowModalModuloRenovacion(true); }}*/}
                        {/*    className="d-none d-sm-block"*/}
                        {/*    disabled*/}
                        {/*>*/}
                        {/*    <span>Agregar Módulo Nuevo</span>*/}
                        {/*</IconButton>*/}
                    </div>
                </Col>
            </Row>

            <hr></hr>
            <Row>
                <Col>
                    {cargando ? <span>Cargando...</span> :
                        idCatTipoLicencia === 7 ?

                            modulosExtraVinculados.length > 0 ? (
                                <Table responsive bordered hover className="mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-start">Descripción</th>
                                            <th className="text-start">Código</th>
                                            <th className="text-start">Paquete</th>
                                            <th className="text-start">Fecha de Vencimiento</th>
                                            <th className="text-start">Status</th>
                                            <th className="text-start"></th>
                                            <th className="text-start"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {modulosExtraVinculados.map((modulo, index) => {

                                            const handleRenovar = () => {
                                                setModuloARenovar(modulo);
                                                setShowConfirmModalRenovar(true);
                                            };

                                            const handleDesvincular = () => {
                                                setModuloADesvincular(modulo);
                                                setShowConfirmModalDesvincular(true);
                                            };

                                            const renderIconWithTooltip = (imgSrc, tooltipText, onClick) => (
                                                <span
                                                    style={{ position: 'relative', display: 'inline-block', cursor: 'pointer' }}
                                                    onClick={onClick}
                                                    onMouseEnter={e => {
                                                        const tooltip = e.currentTarget.querySelector('.tooltip-text');
                                                        if (tooltip) tooltip.style.visibility = 'visible';
                                                    }}
                                                    onMouseLeave={e => {
                                                        const tooltip = e.currentTarget.querySelector('.tooltip-text');
                                                        if (tooltip) tooltip.style.visibility = 'hidden';
                                                    }}
                                                >
                                                    <img src={imgSrc} alt={tooltipText} />
                                                    <span
                                                        className="tooltip-text"
                                                        style={{
                                                            visibility: 'hidden',
                                                            position: 'absolute',
                                                            bottom: '100%',
                                                            left: '50%',
                                                            transform: 'translateX(-50%)',
                                                            marginBottom: '5px',
                                                            padding: '2px 6px',
                                                            borderRadius: '4px',
                                                            backgroundColor: 'black',
                                                            color: 'white',
                                                            fontSize: '0.75rem',
                                                            whiteSpace: 'nowrap',
                                                            zIndex: 100,
                                                        }}
                                                    >
                                                        {tooltipText}
                                                    </span>
                                                </span>
                                            );

                                            return (
                                                <tr key={index}>
                                                    <td className="text-start text-muted align-middle">{modulo.vDescripcionModulo}</td>
                                                    <td className="text-start text-muted align-middle">{modulo.vCodigoModulo}</td>
                                                    <td className="text-start text-muted align-middle">{modulo.vDescripcionPaquete}</td>
                                                    <td className="text-start text-muted align-middle">{modulo.dFinModuloUso}</td>
                                                    <td className="text-start align-middle">
                                                        <span
                                                            className={`badge fw-medium ${modulo.vStatus === 'VENCIDO'
                                                                ? 'bg-danger-subtle text-danger'
                                                                : 'bg-success-subtle text-success'
                                                                }`}
                                                        >
                                                            {modulo.vStatus}
                                                        </span>
                                                    </td>

                                                    {/* Columna Renovar: solo si está vencido */}
                                                    {modulo.vStatus === 'VENCIDO' &&

                                                        <td className="text-center align-middle">
                                                            {renderIconWithTooltip('/img/renew20.png', 'Renovar', handleRenovar)}
                                                        </td>
                                                    }
                                                    {/* Columna Desvincular: siempre visible */}
                                                    <td className="text-center align-middle">
                                                        {renderIconWithTooltip('/img/unsubscribe20.png', 'Desvincular', handleDesvincular)}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>

                            ) : (
                                <p className="mb-0 text-muted">No se encuentran módulos extra vinculados.</p>
                            )

                            :

                            <div className="row">
                                {modulosProVinculados.map((m, index) => (
                                    <div key={index} className="col-12 mb-2">
                                        <Card className="border-0 shadow-sm">
                                            <Card.Body className="py-2 px-3">
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <h6 className="fw-bold mb-1 d-flex align-items-center gap-2">
                                                        {m.vNombreProducto}
                                                        {m.bAplicado ? (
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={<Tooltip>Quitar aplicación</Tooltip>}
                                                            >
                                                                <span
                                                                    role="button"
                                                                    aria-label="Quitar aplicación"
                                                                    className="text-danger ms-1"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => quitarAplicacionModuloPro(m.idOrdenDetalle)}
                                                                >
                                                                    <FontAwesomeIcon icon={faTimes} />
                                                                    <span className="d-none d-md-inline-block ms-1 text-danger fw-bold" style={{ fontSize: '0.9em' }}>Quitar aplicación</span>
                                                                </span>
                                                            </OverlayTrigger>
                                                        ) : (
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={<Tooltip>Aplicar módulo</Tooltip>}
                                                            >
                                                                <span
                                                                    role="button"
                                                                    aria-label="Aplicar módulo"
                                                                    className="text-success ms-1"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => aplicarModuloPro(m.idOrdenDetalle)}
                                                                >
                                                                    <FontAwesomeIcon icon={faCheck} />
                                                                    <span className="d-none d-md-inline-block ms-1 text-success fw-bold" style={{ fontSize: '0.9em' }}>Aplicar</span>
                                                                </span>
                                                            </OverlayTrigger>
                                                        )}
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={<Tooltip>Desvincular de la licencia</Tooltip>}
                                                        >
                                                            <span
                                                                role="button"
                                                                aria-label="Desvincular de la licencia"
                                                                className="text-danger ms-1"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => desvincularModuloPro(m.idOrdenDetalle)}
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </span>
                                                        </OverlayTrigger>
                                                    </h6>

                                                </div>

                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <Badge
                                                                bg={m.iTipoPago === 2 ? "warning" : "info"}
                                                                className="text-white px-2"
                                                            >
                                                                {m.iTipoPago === 2 ? "Renovación" : "Pago Único"}
                                                            </Badge>
                                                            <Badge
                                                                bg={m.bAplicado ? "success" : "secondary"}
                                                                className="px-2"
                                                            >
                                                                {m.bAplicado ? "Aplicado" : "No Aplicado"}
                                                            </Badge>
                                                        </div>

                                                        <div className="d-flex align-items-center gap-4">
                                                            <div>
                                                                <span className="text-muted small me-1">Código:</span>
                                                                <span className="fw-600">{m.vCodigoBarras}</span>
                                                            </div>
                                                            <div>
                                                                <span className="text-muted small me-1">Orden:</span>
                                                                <Link
                                                                    to={"/ordenes/detalle/" + m.idOrden}
                                                                    className="fw-600"
                                                                >
                                                                    #{m.idOrden}
                                                                </Link>
                                                            </div>
                                                            <div>
                                                                <span className="text-muted small me-1">Total:</span>
                                                                <span className="fw-bold text-success">
                                                                    {parseFloat(m.dTotal / m.dCantidad).toLocaleString(
                                                                        "es-MX",
                                                                        {
                                                                            maximumFractionDigits: 2,
                                                                            minimumFractionDigits: 2,
                                                                            style: "currency",
                                                                            currency: "MXN",
                                                                        }
                                                                    )}
                                                                </span>
                                                            </div>
                                                           
                                                            {m.bAplicado && (
                                                                <div>
                                                                    <span className="text-muted small me-1">Aplicación:</span>
                                                                    <span className="fw-600">
                                                                        {new Date(m.dFechaAplicacion).toLocaleDateString(
                                                                            "es-MX",
                                                                            {
                                                                                day: "2-digit",
                                                                                month: "short",
                                                                                year: "numeric",
                                                                            }
                                                                        )}
                                                                    </span>
                                                                </div>

                                                            )}
                                                            {m.iTipoPago === 2 && (
                                                                <div>
                                                                    <span className="text-muted small me-1">Finalización:</span>
                                                                    <span className="fw-600">
                                                                        {new Date(m.dFechaFin).toLocaleDateString("es-MX", {
                                                                            day: "2-digit",
                                                                            month: "short",
                                                                            year: "numeric",
                                                                        })}
                                                                    </span>
                                                                </div>
                                                            )}

                                                            {m.vLastPaymentLink && (
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={<Tooltip>{linkCopiado[m.idOrdenDetalle] ? '¡Copiado!' : 'Copiar link de pago'}</Tooltip>}
                                                                >
                                                                    <span
                                                                        role="button"
                                                                        aria-label="Copiar link de pago"
                                                                        className={`ms-1 ${linkCopiado[m.idOrdenDetalle] ? 'text-success' : 'text-info'}`}
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => copiarLinkPago(m.vLastPaymentLink, m.idOrdenDetalle)}
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={faCopy}
                                                                            spin={copiandoLink[m.idOrdenDetalle]}
                                                                        />
                                                                        <span className="ms-1">{linkCopiado[m.idOrdenDetalle] ? '¡Copiado!' : 'Copiar link de pago'}</span>
                                                                    </span>
                                                                </OverlayTrigger>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                ))}
                            </div>

                    }
                </Col>
            </Row>

            <ModalModulosPro
                idLicencia={idLicencia}
                idCatTipoLicencia={idCatTipoLicencia}
                setModulosProVinculados={setModulosProVinculados}
                setModulosExtraVinculados={setModulosExtraVinculados}
                showModalModuloPRO={showModalModuloPRO}
                setShowModalModuloPRO={setShowModalModuloPRO}
                setCargando={setCargando}
            ></ModalModulosPro>

            {/*<ModalModulosRenovacion                                          */}
            {/*    idLicencia={idLicencia}                                      */}
            {/*    setMensajeError={setMensajeError}                            */}
            {/*    setShowMensajeError={setShowMensajeError}                    */}
            {/*    setMensajeInformativo={setMensajeInformativo}                */}
            {/*    setShowMensajeInformativo={setShowMensajeInformativo}        */}
            {/*    showModalModuloRenovacion={showModalModuloRenovacion}        */}
            {/*    setShowModalModuloRenovacion={setShowModalModuloRenovacion}  */}
            {/*    setModulosProVinculados={setModulosProVinculados}            */}
            {/*/>                                                               */}

            {showConfirmModalDesvincular && (
                <Modal show onHide={() => setShowConfirmModalDesvincular(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>¿Seguro?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Estás seguro que deseas desvincular el módulo <strong>{moduloADesvincular?.vDescripcionModulo}</strong>?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowConfirmModalDesvincular(false)}>
                            Cancelar
                        </Button>
                        <Button variant="danger" onClick={async () => {
                            await DesvincularModuloExtra();
                            setShowConfirmModalDesvincular(false);
                        }}>
                            Desvincular
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            {showConfirmModalRenovar && (
                <Modal show onHide={() => setShowConfirmModalRenovar(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>¿Seguro?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Estás seguro que deseas renovar el módulo <strong>{moduloARenovar?.vDescripcionModulo}</strong>?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowConfirmModalRenovar(false)}>
                            Cancelar
                        </Button>
                        <Button variant="success" onClick={async () => {
                            await RenovarModuloExtra(moduloARenovar);
                            setShowConfirmModalRenovar(false);
                        }}>
                            Renovar
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            <ModalSeleccionarOpcionModulos
                idLicencia={idLicencia}
                showModalOpcionModulos={showModalOpcionModulos}
                setShowModalOpcionModulos={setShowModalOpcionModulos}
                setShowModalModuloPRO={setShowModalModuloPRO}
                setCargando={setCargando}
                handleNuevaOrden={handleAbrirModalNuevaOrden}
            />

            <ModalModulosPRONuevaOrden
                show={showModalModulosPRONuevaOrden}
                setShow={setShowModalModulosPRONuevaOrden}
                idLicencia={idLicencia}
                setModulosProVinculados={setModulosProVinculados}
            />

        </>
    )
}

SeccionModulosPro.propTypes = {
    idLicencia: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idCatTipoLicencia: PropTypes.number,
    setModulosExtraVinculados: PropTypes.func,
    modulosExtraVinculados: PropTypes.array
};

export default SeccionModulosPro;